import { Meteor } from 'meteor/meteor';
import { Accounts } from 'meteor/accounts-base';

import React from 'react';
import { Router, Link, withRouter, browserHistory } from 'react-router';

import MgfForm from '../common/mgfForm';
import { TextField, SubmitField } from 'uniforms-bootstrap3';
import { MontgolfiereSchema, Montgolfieres } from '../../collections/montgolfieres/montgolfieres';

import {
  BPanel,
  Table,
  Button,
  Form,
  FormGroup,
  Col,
  Checkbox,
  ControlLabel,
  FormControl,
  Breadcrumb,
  BreadcrumbItem
} from '@sketchpixy/rubix';

import { Reactive } from '../common/Reactive.mixin';

@Reactive({
	subscriptions: ["montgolfieres"]
})
@withRouter
export default class MontgolfiereEditPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};

		if (!this.props.params.id)
			this.props.router.push('/montgolfieres');
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.isReady && !this.props.isReady)
			this.setState({
				montgolfiere: Montgolfieres.findOne({_id: this.props.params.id})
			});
	}

	handleSubmit(doc) {
		this.props.router.push('/montgolfieres');
	}

	render() {
		return (
			<div>
				<Breadcrumb>
					<Breadcrumb.Item>
						<Link to="/montgolfieres">Montgolfieres</Link>
					</Breadcrumb.Item>


					<Breadcrumb.Item href="#" active>
						Modifier une montgolfiere
					</Breadcrumb.Item>
				</Breadcrumb>

				<BPanel header="Modifier la montgolfiere">
					{ this.props.isReady &&
						<MgfForm schema={MontgolfiereSchema} collection={Montgolfieres} model={this.state.montgolfiere} onSubmit={this.handleSubmit.bind(this)} />
					}
				</BPanel>
			</div>
		);
	}
}




/** WEBPACK FOOTER **
 ** ./src/universal/components/montgolfieres/MontgolfiereEdit.page.js
 **/